var $ = require('jquery');

/**
 *  Logo editor angular application
 */
(function() {
    'use strict';
    var
        logoApp,
        el;

    this.bootstrap = function(_el) {
        el = _el;

        angular.element(el).attr('ng-app', 'logoEditor');
        angular.element(el).attr('ng-controller', 'logoEditorController');

        logoApp = angular.module('logoEditor', ['ngSanitize']);
        // HACK: set an empty defaultFontList value due to changes to the diyfontsproviders service
        logoApp.value('defaultFontList', []);

        /* load directives and services */
        diy.angular.loadDirectives(logoApp, ['diyfontsize', 'diytoggle', 'diycombobox', 'diyfontfamily', 'diyradio', 'diyslider']);
        diy.angular.loadFactories(logoApp, ['diyfileupload', 'diyfontsprovider', 'diyl10n']);

        /* make all $http angular requests to include the CSRF token as well
         and also send data to server in jQuery style because by default angular
         send data as a JSON string and server don't know how to work with this
         type of input */
        logoApp.config(["$httpProvider", function($httpProvider) {
            var defaultHeaders = $httpProvider.defaults.headers;
            // this header is needed in session expiration handling
            defaultHeaders.common['X-Requested-With'] = 'XMLHttpRequest';
            $httpProvider.defaults.transformRequest.push(function(data, headersGetter) {
                var newData = angular.fromJson(data);
                newData.cstok = jimdoData.cstok;
                return jQuery.param(newData);
            });
            /**
             * this assures that the angular app will route all error $http's through session expiry js check
             */
            $httpProvider.interceptors.push(diy.editor.session.angularHandleExpired);
        }]);

        logoApp.controller('logoEditorController', ["$scope", "$http", "$timeout", "diyfontsprovider", "diyfileupload",
            function ($scope, $http, $timeout, diyfontsprovider, diyfileupload) {
                $scope.oldData = null;

                $scope.standardFonts = diyfontsprovider.getStandardFonts();

                /**
                 * set data.type from view
                 * @param type
                 */
                $scope.setLogoType = function (type){
                    $scope.data.type = type;
                };

                /**
                 * deletes the image from the module, partial data is replaced
                 */
                $scope.deleteImage = function (){
                    $scope.data.logoImageExists = false;

                    $scope.data.imageUrl = '';
                    $scope.data.altTag = '';
                    $scope.data.logoImageId = -1;

                    $scope.data.imageWidth = 1;
                    $scope.data.imageHeight = 1;
                    $scope.data.imageRatio = 100;

                    $scope.data.originalImageWidth = $scope.data.imageWidth;
                    $scope.data.originalImageHeight = $scope.data.imageHeight;
                };

                /**
                 * cancel function
                 *
                 * use data previously stored
                 */
                $scope.cancel = function() {
                    if ($scope.oldData) {
                        $scope.data = angular.copy($scope.oldData);
                    }
                    // close the window
                };

                /**
                 * save function
                 *
                 * do not send all the data to the server, is not needed
                 */
                $scope.save = function() {
                    var postData = {
                        type : $scope.data.type,
                        align : $scope.data.align,
                        altTag : $scope.data.altTag,
                        imageRatio : $scope.data.imageRatio,
                        logoSpacing: $scope.data.logoSpacing,
                        text : $scope.data.text,
                        fontFamily : $scope.data.fontFamily,
                        fontSize : $scope.data.fontSize,
                        fontStyle : $scope.data.fontStyle,
                        fontWeight : $scope.data.fontWeight
                    };
                    var logoImageId = parseInt($scope.data.logoImageId,10);
                    if (logoImageId === -1) {
                        postData.logoDeleted = true;
                    }
                    if (logoImageId > 0) {
                        postData.logoImageId = logoImageId;
                    }
                    $scope.clearErrors();

                    $http.post('/app/module/logo/', {
                        data: postData
                    }, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                        }
                    }).success(function(response){
                        if (response.success) {

                            // track logo type changed and saved //
                            if ($scope.data.type !== $scope.oldData.type) {
                                $(document).trigger('diy-editor-generic-linkInteraction', {
                                    actionName: ($scope.data.type === 'text') ? 'LogoAreaTextApplied' : 'LogoAreaImageApplied'
                                });
                            }

                            // track anything changed //
                            if (angular.toJson($scope.data) !== angular.toJson($scope.oldData)) {
                                $(document).trigger('diy-editor-makeWebsiteFit', {
                                    'condition': 'Applied',
                                    'name': 'LogoArea'
                                });
                            }

                            $scope.data.logoImageId = 0;
                            $scope.oldData = angular.copy($scope.data);
                            diy.module.logo.logo.hideEditor();
                        } else {
                            $scope.setErrors(response.errors.error);
                        }
                    }).error(function(errors){
                            $scope.setErrors(errors);
                    });
                };

                $scope.$watch('data', function (newValue, oldValue) {
                    //TODO: check if _disableSync whould be included in this check or not
                    if (oldValue !== undefined && angular.toJson(oldValue) !== angular.toJson(newValue)) {
                        if(newValue.imageRatio !== oldValue.imageRatio){
                            $scope.data.imageWidth = Math.floor(newValue.imageRatio * newValue.originalImageWidth / 100);
                            $scope.data.imageHeight = Math.floor(newValue.imageRatio * newValue.originalImageHeight / 100);
                        }

                        // trigger a VisitedTriedApplied-style tracking call //
                        $(document).trigger('diy-editor-makeWebsiteFit', {
                            'condition': 'Tried',
                            'name': 'LogoArea'
                        });

                        $timeout(function() {
                            diy.module.logo.logo.updatePreview(newValue);
                        });
                    }
                }, true);

                /**
                 * enable error container
                 * @param errors
                 */
                $scope.setErrors = function(errors) {
                    if (typeof errors === "string") {
                        errors = [errors];
                    }
                    $scope.editor.hasErrors = true;
                    $scope.editor.errors = errors;
                };

                /**
                 * hides the error container
                 */
                $scope.clearErrors = function() {
                    $scope.editor.hasErrors = false;
                    $scope.editor.errors = [];
                };

                /**
                 * this function is called when the file input changes
                 * and asks the diythfileupload service to perform the
                 * upload.
                 * @param ev
                 */
                $scope.fileNameChanged = function(ev) {
                    var opts = {
                        inputEl: ev,
                        uploadUrl: '/app/module/logo/upload',
                        timeout: 10000
                    };

                    //$(themingEl).loadingBox({useOverlay: true}).show();

                    diyfileupload.upload(opts).then(
                        function(o) {
                            $scope.clearErrors();
                            $scope.data.imageUrl = o.src;
                            $scope.data.logoImageId = o.logoImageId;

                            $scope.data.imageWidth = o.width;
                            $scope.data.imageHeight = o.height;

                            $scope.data.originalImageWidth = o.width;
                            $scope.data.originalImageHeight = o.height;
                            $scope.data.imageRatio = 100;
                            $scope.data.logoImageExists = true;

                            /*
                            $(themingEl).loadingBox().remove();
                            */
                        },
                        function(errors) {
                            $scope.setErrors(errors);
                        }
                    );
                };
            }
        ]);

        logoApp
            .filter('newlines', function () {
                return function (text) {
                    return text.replace(/\n/g, '<br/>');
                };
            })
            .filter('noHTML', function () {
                return function (text) {
                    return text
                        .replace(/&/g, '&amp;')
                        .replace(/>/g, '&gt;')
                        .replace(/</g, '&lt;');
                };
            })
            .filter('toHTML', function () {
                return function (errors) {
                    var html = '';
                    for (var key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            html +=  errors[key] + '<br/>';
                        }
                    }
                    return html;
                };
            });

        angular.bootstrap(_el, [ 'logoEditor' ]);
    };


    this.init = function(jsonData) {
        this.run(function(scope) {
            if (!jsonData.fontFamily.length) {
                jsonData.fontFamily = scope.standardFonts[0].value;
            }

            jsonData._disableSync = false;

            scope.data = jsonData;
            scope.oldData = angular.copy(jsonData);

            scope.editor = {
                hasErrors: false,
                errors: []
            };
        });
    };

    /**
     * gets the scope
     */
    this.getScope = function() {
        return angular.element(el).scope();
    };

    /**
     * run internal code from outside
     * (eg ajax requests, callbacks, setTimeouts etc)
     */
    this.run = function(f) {
        var scope = this.getScope();
        scope && scope.$apply(f);
    };

    return this;
}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/logo/js/logoApp.js
 ** module id = 1139
 ** module chunks = 0
 **/